import React from 'react';

const Background = () => {
    return (
        <div className='background'>
            <div className='background__shapes'>
                <div className='background__shape background__shape__first'></div>
                <div className='background__shape background__shape__second'></div>
            </div>
        </div>
    );
};

export default Background;